module.exports = __webpack_public_path__ + "@/assets/img/bronz.853e9546.jpeg";